module.exports = __webpack_public_path__ + "static/media/game(18).576cb067.PNG";